import { render, staticRenderFns } from "./detailPenarikan.vue?vue&type=template&id=24558228&scoped=true&"
import script from "./detailPenarikan.js?vue&type=script&lang=js&"
export * from "./detailPenarikan.js?vue&type=script&lang=js&"
import style0 from "./detailPenarikan.scss?vue&type=style&index=0&id=24558228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24558228",
  null
  
)

export default component.exports